<template>
  <div class="text-gray-400 text-xs">
    <p v-if="invite.isRevoked()">
        <i class="fas fa-times mr-1"></i>
        <span class="">Revoked</span>
    </p>
    <p v-else-if="invite.isViewed()">
      <i class="far fa-eye mr-1"></i>
      <span class="">Viewed</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    invite: Object,
  },
}
</script>
